module.exports = "pegasus/assets/blocks/column-18-theme6.png";